import React from 'react';
import styles from './FeaturedPlayerCard.module.scss';
import PlaceholderJugador from 'containers/Mundial2026/assets/placeholders/Jugador.png';

const FALLBACK_COLOR = '#f77f00';

const FeaturedPlayerCard = ({ headline = '', player = {}, color }) => {
  const {
    name = '',
    position = '',
    image,
    value,
  } = player;

  const safeValue = value === null || value === undefined ? '—' : value;

  return (
    <article
      className={styles['featured-player-card']}
      style={{ '--wc-fpc-color': color || FALLBACK_COLOR }}
    >
      <div className={styles['featured-player-card__image-frame']}>
        <img
          className={styles['featured-player-card__image']}
          src={image || PlaceholderJugador}
          alt=""
          onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = PlaceholderJugador; }}
        />
      </div>
      <div className={styles['featured-player-card__body']}>
        <div className={styles['featured-player-card__identity']}>
          <p className={styles['featured-player-card__name']} title={name}>
            {name}
          </p>
          <p
            className={styles['featured-player-card__position']}
            title={position}
          >
            {position}
          </p>
        </div>
        <div className={styles['featured-player-card__metric']}>
          <p className={styles['featured-player-card__metric-label']}>
            {headline}
          </p>
          <p className={styles['featured-player-card__metric-value']}>
            {safeValue}
          </p>
        </div>
      </div>
    </article>
  );
};

export default FeaturedPlayerCard;
